'use client'

import { useEffect } from 'react'
import { useStore } from '@/hooks/useStore'

export default function ThemeProvider({ children }: { children: React.ReactNode }) {
  const { theme } = useStore()

  useEffect(() => {
    // Set the data-theme attribute on the html element
    document.documentElement.setAttribute('data-theme', theme)
    // Optional: toggle dark class if needed by other libraries
    if (theme === 'dark') {
      document.documentElement.classList.add('dark')
    } else {
      document.documentElement.classList.remove('dark')
    }
  }, [theme])

  return <>{children}</>
}
